import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import Api from "../../services/Api";
import logo from "../../asessts/Images/logo.png";
import loginImg from "../../asessts/Images/login_img.png";
import mailIcon from "../../asessts/Images/mail_icon.svg";

function VerifyEmail() {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleResendOtp = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Please enter your email");
      return;
    }

    try {
      setIsLoading(true);
      const response = await Api.resendOTP(email);
      if (response.status === 200 || response.status === true) {
        localStorage.setItem("careCred", JSON.stringify({ email }));
        localStorage.setItem("flowType", "forgot-password");

        toast.success("OTP sent to your email");
        navigate("/verify-otp");
      }
    } catch (error) {
      toast.error("Failed to send OTP");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="for-overlay">
      <section id="Dashboard-login-main">
        <div className="dashboard-input-left">
          <div className="logo">
            <a href="#">
              <img src={logo} alt="Logo" />
            </a>
          </div>

          <div className="login-input-details">
            <h2>Verifying Email</h2>
            <p>Please enter your email to receive OTP</p>

            <form onSubmit={handleResendOtp}>
              <div className="input-group">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter Email Address"
                />
                <span className="icon">
                  <img src={mailIcon} alt="" />
                </span>
              </div>

              <div className="login-btn">
                <button type="submit" disabled={isLoading}>
                  {isLoading ? "Sending..." : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>

        <div className="login-img-right">
          <img src={loginImg} alt="Illustration" />
        </div>
      </section>
    </div>
  );
}

export default VerifyEmail;
